import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import PageLoading from './components/shared/PageLoading'
import Navbar from '@/components/layout/Navbar';

Vue.config.productionTip = false

Vue.component('PageLoading', PageLoading)
Vue.component('Navbar', Navbar)

Vue.filter('dateTime', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    return formattedDate.toLocaleString('pt-BR');
  } else {
    return 'Data inválida';
  }
})

Vue.filter('dateMonthYear', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    const options = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    };
    return formattedDate.toLocaleString('pt-BR', options);
  } else {
    return 'Data inválida';
  }
})

Vue.filter('price', price => {
  price = String(price).replace(',', '.');
  price = Number(price);
  if (!isNaN(price)) {
    return price.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  } else {
    return ''
  }
})

const token = sessionStorage.getItem('@SyclusPedidos:token') && JSON.parse(sessionStorage.getItem('@SyclusPedidos:token'))
const tokens = localStorage.getItem('@SyclusPedidos:tokens') && JSON.parse(localStorage.getItem('@SyclusPedidos:tokens'))
const licencas = localStorage.getItem('@SyclusPedidos:licencas') && JSON.parse(localStorage.getItem('@SyclusPedidos:licencas'))

if (token) {
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })

    // Inicializa o backup de tempo em tempo
    store.dispatch('verifyAndSendBackupOnline')

    // Carrega as configurações do sistema salvas no localStorage
    store.dispatch('loadConfiguracoes')
} else if (tokens && tokens.length) {
  const [token] = tokens
  
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })

    // Inicializa o backup de tempo em tempo
    store.dispatch('verifyAndSendBackupOnline')

    // Carrega as configurações do sistema salvas no localStorage
    store.dispatch('loadConfiguracoes')
} else {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}